/* global angular, _, jQuery, mintel_tracking*/

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.directive('trModal', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element) {
            scope.setState = function (newState) {
                scope.state = newState;
            };

            scope.close = function () {
                scope.$hide();
            };

            scope.state = scope.initialState || 'initial';
            if (scope.data === undefined) {
                scope.data = scope.initialData ? angular.copy(scope.initialData()) : {};
            }

            var successStates = scope.successStates || ['success'];
            var timeout = null;
            scope.$watch('state', function (newState, oldState) {
                if (timeout) {
                    $timeout.cancel(timeout);
                    timeout = null;
                }
                if (_.includes(successStates, newState)) {
                    timeout = $timeout(scope.close, 1250);
                }

                if (scope.transientDataSourceState !== newState) {
                    delete scope.transientData;
                }

                scope.$emit('modal.state', { newState: newState, oldState: oldState, data: scope.data });
                var content = element.find('.modal-content');
                if (content) {
                    $timeout(function() {
                        content.focus();
                    });
                }
            });

            scope.$on('modal.setstate', function (evt, newState, data) {
                scope.state = newState;
                if (data) {
                    scope.transientDataSourceState = newState;
                    scope.transientData = data;
                }
            });

            scope.$on('modal.close', function() {
                scope.close();
            });
        }
    };
}]);

ngModule.directive('modalLauncher', ['ModalManager', function (ModalManager) {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
            var template = attrs.modalLauncher;

            element.bind('click', function () {
                ModalManager.create({scope: scope, template: template});
            });
            element.bind('keypress', function (event) {
                if (event.which === 13 || event.keyCode === 13) {
                    event.preventDefault();
                    ModalManager.create({scope: scope, template: template});
                }
                return true;
            });
        }
     };
}]);

ngModule.directive('webinarAction', ['ModalManager', '$window',
    function(ModalManager, $window) {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope) {
                var template = '/trends/partials/webinar/';

                scope.doWebinarAction = function () {
                    if (scope.flashAvailable()) {
                        ModalManager.create({scope: scope, template: template});
                    } else {
                        $window.location = scope.item.ppt_link;
                    }
                };
            }
        };
    }]);

ngModule.directive('validationModalLauncher', ['ModalManager', function(ModalManager) {
    return {
        restrict: 'A',
        scope: true,
        link: function(scope, elements, attrs) {
            var template = '/trends/partials/validation/' + attrs.validationModalLauncher;

            scope.launchValidationModal = function(confirmCallback, params) {
                var newScope = angular.extend(scope.$new(), {
                    params: params,
                    confirmCallback: confirmCallback
                });

                ModalManager.create({
                    scope: newScope,
                    template: template
                });
            };
        }
    };
}]);

ngModule.directive('pptPreviewModalLauncher', ['Restangular', 'PptService', '$alert',
        'ModalManager', function (Restangular, PptService, $alert, ModalManager) {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope) {
            var template = '/trends/partials/ppt_preview/';
            scope.showPptPreview = function(ppt_id){
                scope.ppt_id = ppt_id;
                ModalManager.create({scope: scope, template: template.concat(ppt_id)});
            };
            scope.$watch(function() {
                return PptService.ppts;
            }, function () {
                scope.ppts_with_slide = {};
                scope.ppts = PptService.ppts;
                for (var key in scope.ppts){
                    var o = scope.ppts[key];
                    if (o.items !== undefined && o.items.length > 0){
                        scope.ppts_with_slide[key] = o;
                    }
                }
            });

            scope.$on('modal.setstate', function (evt, newState, data) {
                scope.state = newState;
                if (data) {
                    scope.transientDataSourceState = newState;
                    scope.transientData = data;
                }
            });
        }
     };
}]);
ngModule.directive('savedSearchModalLauncher', ['Api', 'ModalManager', 'EmailAlertManagerFactory',
    function (Api, ModalManager, EmailAlertManagerFactory) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element) {
                // Instantiate and alert manager to provide access to frequencies
                var alertManager = new EmailAlertManagerFactory('dummy');

                scope.initialData = function () {
                    return {
                        frequencies: alertManager.frequencies(),
                        form: {
                            name: scope.params.q,
                            frequency: alertManager.defaultFrequency().pk
                        },
                    };
                };

                scope.$on('modal.state', function (evt, args) {
                    if (args.newState === 'submit') {
                        var params = angular.copy(args.data.form);
                        params.search_criteria = angular.copy(scope.params);
                            return Api.alerts.savedsearch.post(params).then(function () {
                                if (params.frequency === 1) {
                                    scope.$broadcast('modal.setstate', 'success-no-alert');
                                }
                                else {
                                    scope.$broadcast('modal.setstate', 'success');
                                }
                            }, function () {
                                scope.$broadcast('modal.setstate', 'error');
                            });
                    }
                });

                element.bind('click', function () {
                    ModalManager.create({scope: scope, template: '/trends/partials/save_search/'});
                });
                element.bind('keypress', function (event) {
                    if (event.which === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        ModalManager.create({scope: scope, template: '/trends/partials/save_search/'});
                    }
                    return true;
                });
            }
        };
    }]);

ngModule.directive('emailAlertModalLauncher', ['EmailAlertManagerFactory', 'ModalManager',
    function (EmailAlertManagerFactory, ModalManager) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var alertType = attrs.emailAlertModalLauncher;
                var targetItem = scope.$eval(attrs.targetItem);
                var targetId = targetItem[alertType + '_id'];

                var alertManager = new EmailAlertManagerFactory(alertType);

                var alertIsSet = function () {
                    return alertManager.alertIsSet(targetId);
                };

                scope.initialData = function () {
                    if (alertIsSet()) {
                        return {};
                    } else {
                        return {
                            frequencies: alertManager.frequencies(),
                            form: {
                                name: targetItem.description,
                                frequency: alertManager.defaultFrequency().pk
                            },
                        };
                    }
                };

                scope.getMode = function () {
                    var stat = alertIsSet(alertType, targetId);
                    switch (stat) {
                        case true:
                            return 'remove';
                        case false:
                            return 'add';
                        default:
                            return null;
                    }
                };

                if (attrs.preloadAlerts) {
                    alertManager.preloadAlerts();
                }

                scope.$on('modal.state', function (evt, args) {
                    if (args.newState === 'submit') {
                        var promise = alertIsSet() ?
                            alertManager.removeAlert(targetId) :
                            alertManager.setAlert(targetId, args.data.form);

                        promise.then(function () {
                            scope.$broadcast('modal.setstate', 'success');
                        }, function () {
                            scope.$broadcast('modal.setstate', 'error');
                        });
                    }
                });

                scope.$watch(scope.getMode, function (newValue) {
                    if (newValue) {
                        element.show();
                    } else {
                        element.hide();
                    }
                });

                element.bind('click', function () {
                    ModalManager.create({scope: scope, template: '/trends/partials/alerts/' + scope.getMode() + '/'});
                });

                element.bind('keypress', function (event) {
                    if (event.which === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        ModalManager.create({scope: scope, template: '/trends/partials/alerts/' +
                            scope.getMode() + '/'});
                    }
                    return true;
                });
            }
        };
    }]);

ngModule.directive('feedbackModalLauncher', ['ModalManager', '$location', 'Api',
    function (ModalManager, $location, Api) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element) {
                if ($location.path().replace('/', '') === 'logged_off') {
                    $('#feedback-button').css('display', 'none');
                }
                scope.initialData = function () {
                    return {
                        form: {}
                    };
                };

                scope.$on('modal.state', function (evt, args) {
                    if (args.newState === 'submit') {
                        var form = angular.extend({ referrer: $location.absUrl() }, args.data.form);
                        Api.feedback.post(form).then(function () {
                            scope.$broadcast('modal.setstate', 'success');
                        }, function () {
                            scope.$broadcast('modal.setstate', 'error');
                        });
                    }
                });

                element.bind('click', function () {
                    ModalManager.create({scope: scope, template: '/trends/partials/feedback/'});
                });
            }
        };
    }]);

ngModule.directive('exportModalLauncher', ['ModalManager', 'Api', function (ModalManager, Api) {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element, attrs) {
            var item_id = scope.$parent.$eval(attrs.exportModalLauncher);

            scope.initialState = 'submit';

            scope.$on('modal.state', function (evt, args) {
                if (args.newState === 'submit') {
                    Api.export_basket.post({ ids: [ { item_id: item_id } ] }).then(function () {
                        scope.$broadcast('modal.setstate', 'success');
                    }, function () {
                        scope.$broadcast('modal.setstate', 'error');
                    });
                }
            });

            element.bind('click', function () {
                ModalManager.create({scope: scope, template: '/trends/partials/export/add/'});
            });
        }
     };
}]);

ngModule.directive('searchSelectionModalLauncher', ['$window', 'Api', 'DownloadManager', 'ModalManager',
    function ($window, Api, DownloadManager, ModalManager) {
        return {
            require: '^searchSelectionManager',
            restrict: 'A',
            scope: {},
            templateUrl: null,
            link: function (scope, element, attrs, selectionCtrl) {
                scope.getSelectionCount = _.bind(selectionCtrl.getSelectionCount, selectionCtrl);

                scope.initialData = function () {
                    return {
                        selections: _.reduce(selectionCtrl.selectionDetail, function (result, v, k) {
                            result[k] = true;
                            return result;
                        }, {}),

                        detail: _.reduce(selectionCtrl.selectionDetail, function (result, v, k) {
                            if (!result[v.type]) {
                                result[v.type] = [];
                            }
                            result[v.type].push(angular.extend({ id: k }, v));
                            return result;
                        }, {}),

                        types: [
                            {name: 'trend', description: 'Trends'},
                            {name: 'observation', description: 'Observations'},
                            {name: 'mapp', description: 'Applications'}
                        ]
                    };
                };

                scope.successStates = ['export_success', 'download_success', 'selection_success'];

                scope.launchModal = function (initialState) {
                    ModalManager.create({scope: scope, template: '/trends/partials/search/selections/'});
                    scope.initialState = initialState;
                };

                scope.$on('modal.state', function (evt, args) {
                    switch (args.newState) {
                        case 'export':
                            var ids = _.reduce(args.data.selections, function (result, v, k) {
                                if (v) {
                                    result.push({item_id: parseInt(k)});
                                }
                                return result;
                            }, []);
                            Api.export_basket.post({ ids: ids }).then(function () {
                                scope.$broadcast('modal.setstate', 'export_success');
                            }, function () {
                                scope.$broadcast('modal.setstate', 'export_error');
                            });
                            break;

                        case 'selection':
                            var ids = _.keys(_.pick(args.data.selections, function (v) { return !v; }));
                            selectionCtrl.removeSelections(ids);
                            scope.$broadcast('modal.setstate', 'selection_success');
                            break;

                        case 'download':
                            var ids = _.keys(_.pick(args.data.selections, function (v) { return v; }));
                            DownloadManager.downloadPDF('list', ids.join('+'), args.data.values).then(
                                function (response) {
                                    scope.$broadcast('modal.setstate', 'download_success');
                                    $window.location = response;
                                }, function (error) {
                                    switch (error) {
                                        case 'download_warning':
                                        case 'blocked':
                                            scope.$broadcast('modal.setstate', error);
                                            break;
                                        default:
                                            scope.$broadcast('modal.setstate', 'download_error');
                                    }
                                }, function (percent_complete) {
                                    scope.$broadcast('modal.setstate', 'download_progress', percent_complete);
                                }
                            );
                            break;
                    }
                });
            }
        };
    }]);

ngModule.directive('pptbuilderModalLauncher', ['ModalManager', '$location', 'Api', 'HistoricContext',
                                               '$alert', 'TagManager',
    function (ModalManager, $location, Api, HistoricContext, $alert, TagManager) {
        return {
            require: '?^searchSelectionManager',
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs, ctrl) {
                /* This bit needs to be refactored. */
                var isMultiItemSelection = ctrl !== undefined && !attrs.singleItemSelection;

                var refresh_ppt_section = function() {
                    scope.ppt_section = attrs.pptSection;
                    if (scope.ppt_section === 'statistics-panel' ||
                        scope.ppt_section === 'observation-statistics-panel'){
                        scope.ppt_section = scope.ppt_section.concat('-').concat(attrs.pptPanelId);
                    }
                    else if (scope.ppt_section === 'history') {
                       scope.ppt_section = scope.ppt_section.concat('-').concat(attrs.pptHistorySelector);
                    }
                    else if (scope.ppt_section === 'observation-statistic'){
                        scope.ppt_section = scope.ppt_section.concat('-').concat(attrs.pptStatisticId);
                    }
                };
                refresh_ppt_section();

                scope.maxNumberSlides = 25;
                scope.maxNumberPpts = 20;
                if (!isMultiItemSelection) {
                    scope.popoverPptSelectionLimitContent = 'The maximum number of slides per presentation (' +
                                                        scope.maxNumberSlides +
                                                        ') has been reached. You will need to delete ' +
                                                        'a slide in your presentation before adding a new one.';
                }
                else {
                    scope.popoverPptSelectionLimitContent = 'The maxium number of slides per presentation is ' +
                                                        scope.maxNumberSlides +
                                                        '. You will need to reduce the number of ' +
                                                        'selections before adding them or delete ' +
                                                        'slides in your presentation to make room for new ones.';
                }
                scope.popoverPptLimitContent = 'The maximum number of presentations per user (' +
                                               scope.maxNumberPpts +
                                               ')  has been reached. You will need to delete ' +
                                               'a presentation before creating a new one';

                scope.pptLimitReached = function() {
                    return Object.keys(scope.ppts).length >= scope.maxNumberPpts;
                };
                scope.pptSelectionLimitReached = function(pptId) {
                    if (scope.ppts === undefined || scope.ppts[pptId] === undefined) {
                        return false;
                    }
                    var selectionCount = attrs.selectionCount || '1';
                    return scope.ppts[pptId].item_count + parseInt(selectionCount) > scope.maxNumberSlides;
                };



                /* Get the type of the object, this is used serverside to decide how to store the
                item */
                var get_target_type = function(ppt_section){
                    var target_type = 'item';
                    if (ppt_section.indexOf('heatmap') > -1 ||
                        ppt_section.indexOf('trendscape') > -1)
                    {
                        target_type = 'svg';
                    }
                    else if (ppt_section.indexOf('hvt') > -1) {
                        target_type = 'hvt';
                    }

                    return target_type;
                };

                /* process the ppt_section based on the attrs of the directive */
                var process_ppt_section = function(ppt_section) {
                    //The selected region/content/hvt is only available at this point
                    if (scope.ppt_section.indexOf('regional-context') > -1) {
                        ppt_section = ppt_section.concat('-').concat(
                            attrs.pptImplicationId
                        ).concat('-').concat(attrs.pptContext);
                    }
                    else if (scope.ppt_section.indexOf('wiif') > -1) {
                        ppt_section = ppt_section.concat('-').concat(attrs.pptImplicationId);
                    }
                    else if (scope.ppt_section.indexOf('report-section') > -1) {
                       // This data is later split on '-', the
                       // hvt value of other is -1 which causes an issue
                       // with that so replace it with an explicity special
                       // case
                        var hvtVal = element.attr('data-ppt-hvt-id');
                        if (element.attr('data-ppt-hvt-id') === '-1') {
                            hvtVal = 'other';
                        }

                        ppt_section = ppt_section.concat('-').concat(
                            hvtVal
                        ).concat('-').concat(element.attr('data-ppt-mt-id'));
                    }
                    else if (scope.ppt_section === 'statistic'){
                        var panel_id = attrs.pptParentPanelId;
                        ppt_section = ppt_section.concat('-').concat(
                            panel_id
                        ).concat('-').concat(attrs.pptStatisticId);
                    }

                    return ppt_section;
                };

                var build_item = function(ppt_id, ppt_section, hash) {
                    var item = {
                        /* element.attr used instead of attrs to handle adding dynamically that attribute */
                        'target_id': element.attr('data-pptbuilder-modal-launcher'),
                        'target_type': get_target_type(scope.ppt_section),
                        'ppt_id': ppt_id,
                        'ppt_section': ppt_section,
                        'ppt_section_content_hash': hash
                    };

                    if (item.target_type === 'svg') {
                        item.target_id = -1;
                        item.display_url = window.location.pathname + window.location.hash;

                        var svg = element.parent().find('svg')[0];
                        // set the svg to the size of the ppt image
                        if (ppt_section.indexOf('heatmap') > -1) {
                            scope.redraw(681, 416);
                        }
                        else if (ppt_section.indexOf('trendscape') > -1) {
                            scope.redraw(850, 416);
                        }

                        item.svg = (new XMLSerializer()).serializeToString(svg);

                        // restore to its original size
                        scope.redraw();
                    }

                    return item;
                };

                var createSelectionForm = function(selectedPpts) {
                    var form = {};
                    var ppt_section = scope.ppt_section;
                    ppt_section = process_ppt_section(ppt_section);

                    form.objects = [];
                    for(var d in selectedPpts) {
                        if (parseInt(d) !== -1 && selectedPpts[d] === true) {
                            var item = build_item(d, ppt_section, '');
                            form.objects.push(item);
                        }
                    }

                    return form;
                };

                var postPptSelection = function(form) {
                    angular.forEach(form.objects, function (obj) {
                        TagManager.event('add-to-ppt', {
                            category: obj.ppt_section.split('-')[0],
                            pptSection: obj.ppt_section,
                            pptTarget: obj.target_id
                        });
                    });

                    var promise = Api.pptSelection.post(form).then(function () {
                        // store the recently added-to ppts in local storage
                        var selectedPpts = [];
                        for (var i = 0; i < form.objects.length; i++) {
                            var ppt = form.objects[i].ppt_id;
                            selectedPpts.push(ppt);
                        }
                        HistoricContext.insert('recent_ppts', selectedPpts, 'local');
                        HistoricContext.save();

                        scope.$emit('reloadPpts', form);
                        scope.$broadcast('modal.close');

                        // TODO: translation when in the distant future a system for translations in
                        // dynamic javascript is implemented
                        var alrt = $alert({
                            title: 'Success!',
                            content: 'Item successfully added to presentation.',
                            type: 'success',
                            container: 'body',
                            placement: 'ppt-alert',
                            dismissable: false,
                            show: false,
                            duration: 1.5
                        });
                        alrt.$promise.then(function() { alrt.show(); });

                    }, function () {
                        scope.$broadcast('modal.setstate', 'error');
                    });
                    return promise;
                };

                var initialDataFct = function(data) {
                    data.ppts = [];
                    data.selectedPpts = {};
                    data.arePptsFull = {};
                    data.newPptName = '';
                    var nameAlreadyExistsAlert = $alert({
                        title: 'Error!',
                        content: '<span style="padding-right: 20px">A presentation with the same name already exists.' +
                        'Please choose a different name</span>.',
                        type: 'danger',
                        container: '.pptbuilder-form',
                        placement: 'pptbuilder-form',
                        dismissable: 'true',
                        show: false,
                        duration: false
                    });

                    data.anyPptSelected = function() {
                        if (data.newPptName !== '') {
                            var nameAlreadyExists = false;
                            for (var i in scope.ppts){
                                if (scope.ppts[i].name === data.newPptName){
                                    nameAlreadyExists = true;
                                }
                            }
                            if (nameAlreadyExists){
                                nameAlreadyExistsAlert.show();
                                return false;
                            } else {
                                nameAlreadyExistsAlert.hide();
                                return true;
                            }
                        } else {
                            for (var d in data.selectedPpts) {
                                if(data.selectedPpts[d] === true) {
                                    return true;
                                }
                            }
                            return false;
                        }
                    };

                    data.resetSelectedPpts = function(event) {
                        if (event.which !== 9 && event.keyCode !== 9) {
                            for (var d in data.selectedPpts) {
                                data.selectedPpts[d] = false;
                            }
                        }
                    };

                    var promise = Api.ppt.getList().then(function(response) {
                        scope.ppts = {};
                        for (var i=0; i<response.length; i++) {
                            data.ppts.push(response[i]);
                            scope.ppts[response[i].pk] = response[i];
                            if (scope.pptSelectionLimitReached(response[i].pk)) {
                                data.arePptsFull[response[i].pk] = true;
                            }
                        }

                        // Select the ppts that were most recently added to
                        var recentPpts = HistoricContext.getValue('recent_ppts');
                        if (recentPpts) {
                            var pptIds = _.pluck(data.ppts, 'pk');
                            for (var i = 0; i < recentPpts.length; i++) {
                                /* If a deck is stored locally as recently added-to but isn't returned
                                   by the API then don't try to select it - it has likely been deleted */
                                if (
                                    _.contains(pptIds, parseInt(recentPpts[i])) &&
                                    !scope.pptSelectionLimitReached(recentPpts[i])
                                ) {
                                    data.selectedPpts[recentPpts[i]] = true;
                                }
                            }
                        }

                        // Sort ppts so pre-selected ones appear first
                        data.ppts.sort(function (a, b) {
                            if (!data.selectedPpts[a.pk] && data.selectedPpts[b.pk]) {
                                return 1;
                            } else if (data.selectedPpts[a.pk] && !data.selectedPpts[b.pk]) {
                                return -1;
                            } else if (data.arePptsFull[a.pk] && !data.arePptsFull[b.pk]){
                                return 1;
                            } else if (!data.arePptsFull[a.pk] && data.arePptsFull[b.pk]) {
                                return -1;
                            } else if(scope.ppts[a.pk].name < scope.ppts[b.pk].name) {
                                return -1;
                            } else if(scope.ppts[a.pk].name > scope.ppts[b.pk].name) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });
                    });

                    return promise;
                };
                scope.$on('modal.state', function (evt, args) {
                    if (args.newState === 'submit') {
                        /* When the ctrl is defined, we have to handle a multi items selection. */
                        if (isMultiItemSelection) {
                            var ppt_section_type_mapping = {
                                'trend': 'trend-cover', 'observation': 'observation-cover', 'mapp': 'report-section'
                            };
                            var createSelectionItems = function(selection) {
                                angular.forEach(selection, function(value, key) {
                                    if (value.type === 'mapp') {
                                        element.attr('data-ppt-mt-id', key);
                                        element.attr('data-pptbuilder-modal-launcher', value.trendId);
                                        element.attr('data-ppt-hvt-id', value.hvtId);
                                    }
                                    else {
                                        element.attr('data-pptbuilder-modal-launcher', key);
                                    }
                                    scope.ppt_section = ppt_section_type_mapping[value.type];
                                    var ppt_section = scope.ppt_section;
                                    ppt_section = process_ppt_section(ppt_section);
                                    var selectionForm = createSelectionForm(args.data.selectedPpts);
                                    postPptSelection(selectionForm);
                                });
                            };
                            if (!args.data.newPptName) {
                                    createSelectionItems(ctrl.selectionDetail);
                            }
                            else {
                                var key = Object.keys(ctrl.selectionDetail)[0];
                                var value = ctrl.selectionDetail[key];
                                if (value.type === 'mapp') {
                                    element.attr('data-ppt-mt-id', key);
                                    element.attr('data-pptbuilder-modal-launcher', value.trendId);
                                    element.attr('data-ppt-hvt-id', value.hvtId);
                                }
                                else {
                                    element.attr('data-pptbuilder-modal-launcher', key);
                                }
                                scope.ppt_section = ppt_section_type_mapping[value.type];
                                var ppt_section = scope.ppt_section;
                                ppt_section = process_ppt_section(ppt_section);
                                var selectionForm = createSelectionForm(args.data.selectedPpts);
                                if(args.data.newPptName) {
                                var form = {'name': args.data.newPptName};
                                Api.ppt.post(form).then(function(response) {
                                    mintel_tracking.engage('Sidebar', {
                                        'Panel': 'My Presentations',
                                        'Action': 'Create Presentation',
                                        'Presentation Title': args.data.newPptName
                                    });
                                    var item = build_item(response.pk, ppt_section, '');
                                    scope.$emit('reloadPpts');
                                    selectionForm.objects.push(item);
                                    var p = postPptSelection(selectionForm);
                                    var remainingSelectionDetail = angular.copy(ctrl.selectionDetail);
                                    delete remainingSelectionDetail[key];
                                    p.then(function() {
                                        args.data.selectedPpts[response.pk] = true;
                                        createSelectionItems(remainingSelectionDetail);
                                    });
                                }, function(response){
                                    if (response.data === 'PPTNameAlreadyExists') {
                                        scope.$broadcast('modal.setstate', 'error_name_already_exists');
                                    } else {
                                        scope.$broadcast('modal.setstate', 'error');
                                    }
                                });
                                }
                            }
                        }
                        else {
                            refresh_ppt_section();
                            var ppt_section = scope.ppt_section;
                            ppt_section = process_ppt_section(ppt_section);
                            var selectionForm = createSelectionForm(args.data.selectedPpts);

                            if(args.data.newPptName) {
                                var form = {'name': args.data.newPptName};
                                Api.ppt.post(form).then(function(response) {
                                    mintel_tracking.engage('Sidebar', {
                                        'Panel': 'My Presentations',
                                        'Action': 'Create Presentation',
                                        'Presentation Title': args.data.newPptName
                                    });
                                    var item = build_item(response.pk, ppt_section, '');
                                    scope.$emit('reloadPpts');
                                    selectionForm.objects.push(item);
                                    postPptSelection(selectionForm);
                                }, function(response){
                                    if (response.data === 'PPTNameAlreadyExists') {
                                        scope.$broadcast('modal.setstate', 'error_name_already_exists');
                                    } else {
                                        scope.$broadcast('modal.setstate', 'error');
                                    }
                                });
                            }
                            else {
                                postPptSelection(selectionForm);
                            }
                        }
                    }
                });

                function getItemAttrs(element) {
                    var item = Object;
                    item.itemTitle = element.getAttribute('data-item-title');
                    item.itemDisplaydate = element.getAttribute('data-item-displaydate');
                    item.contentType = element.getAttribute('data-content-type');
                    return item;
                }

                element.bind('click', function () {
                    scope.$emit('pptBind', getItemAttrs(this));
                    ModalManager.create({scope: scope, template: '/trends/partials/pptbuilder/'}, initialDataFct);
                });

                element.bind('keypress', function (event) {
                    if (event.which === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        scope.$emit('pptBind', getItemAttrs(this));
                        ModalManager.create({scope: scope, template: '/trends/partials/pptbuilder/'}, initialDataFct);
                    }
                    return true;
                });
            }
        };
    }]);

ngModule.directive('pptbuilderFormHandler',
    function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element) {
                var textarea = element.find('#new-ppt-name');
                textarea.keydown(function(event) {
                    if (event.keyCode === 13) {
                        if (textarea.val().trim() !== '') {
                            scope.$apply(function() {
                                scope.setState('submit');
                                return false;
                            });
                        }
                        else {
                            return false;
                        }
                    }
                });
            }
        };
    });
